// extracted by mini-css-extract-plugin
module.exports = {"colorPopup":"#363738","colorBackground05":"rgba(42,45,44,0.5)","container":"VestingInfoBox_container__3y799","text":"VestingInfoBox_text__YzIWw"};